<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="toggleFiltre()">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{$t('detailPlanningReseauLc.filtreContent.titre')}}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{$t('detailPlanningReseauLc.filtreContent.appliquerFiltre')}}
        </span>
      </div>
    </div>
    <div class="column overflow-auto hauteur-brief-filtre" v-if="filtreStock">
      <div class="columns is-multiline is-12 is-marginless is-paddingless">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailPlanningReseauLc.filtreContent.codeReseau')">
            <b-input v-model="filtreStock.reference">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailPlanningReseauLc.filtreContent.libelle')">
            <b-input v-model="filtreStock.libelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailPlanningReseauLc.filtreContent.villes')">
              <ville-tag-input-auto-complete
                  :critere-recherche="filtreStock"
                  table-name="Produit"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailPlanningReseauLc.filtreContent.formats')">
            <qd-taginput v-if="formatTags"
                        :data="formatTags"
                        v-model="formatSelected"
                        autocomplete
                        open-on-focus
                        field="libelle"
                        type="is-primary"
                        icon="magnify"
                        @input="getFormatTag"
                        @typing="getFilteredFormatTags">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('detailPlanningReseauLc.filtreContent.reseauConfrere')">
            <qd-switch v-model="filtreStock.inclureConfreres">
            </qd-switch>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-brief-filtre border-pied pdt-0">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="saveFiltre()">
        {{$t('detailPlanningReseauLc.filtreContent.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pdl-10px"
        @click="viderFiltre()">
        {{$t('detailPlanningReseauLc.filtreContent.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheReseauLc from '@/services/planningReseauLc/genererCritereRechercheReseauLc';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  components: {
    VilleTagInputAutoComplete,
  },
  data() {
    return {
      filtreStock: null,
      typesParametres: typesParametres,
      formatTags: null,
      listeFormatBase: null,
      formatSelected: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getFilteredFormat() {
      return this.getFormat.filter((format) => {
        return !this.filtreStock.formats.find((formatInFiltre) => {
          return formatInFiltre === format.id;
        });
      });
    },
    getFormat() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.format).filter(f => f.actif);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getFilteredFormatTags(text) {
      this.getFormatTag();
      this.formatTags = this.formatTags.filter((format) => {
        return format.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFormatTag() {
      this.formatTags = this.listeFormatBase.filter((format) => {
        return !this.formatSelected.map(f => f.id).includes(format.id);
      });
    },
    viderFiltre() {
      this.filtreStock = cloneDeep(genererCritereRechercheReseauLc());
      this.formatSelected = [];
      this.getFormatTag();
    },
    saveFiltre() {
      this.filtreStock.formats = this.formatSelected.map((format) => { return format.id; });
      this.$emit('input', this.filtreStock);
      this.$emit('appliquerFiltre', this.filtreStock);
    },
    toggleFiltre() {
      this.$emit('toggleFiltre');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.filtreStock = cloneDeep(this.value);
        await this.loadParametres([typesParametres.PARAMETRES_KEYS.format]);
        this.listeFormatBase = this.getFormat;
        this.formatTags = this.listeFormatBase;
        if (this.filtreStock.formats) {
          this.formatSelected = this.listeFormatBase.filter((format) => {
            return this.filtreStock.formats.includes(format.id);
          });
        }
        this.getFormatTag();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
